import { Typography } from "@mui/material";
import { IconType } from "core/types";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { dp, margin } from "ds_legacy/materials/metrics";
import { Title } from "ds_legacy/materials/typography";
import React from "react";
import { useTranslations } from "translations";

export function GeneralTableTitle({
  count = 0,
  description,
  filteredCount,
  iconProps,
  title,
  variant = "default",
}: {
  count: number;
  description?: string | React.JSX.Element;
  filteredCount?: number;
  iconProps?: {
    Icon: IconType;
  };
  title: string;
  variant?: "minimal" | "default";
}) {
  const translations = useTranslations();
  const displayTitle = `${title} ${
    filteredCount != null
      ? `(${translations.userManagement.numberAccounts({
          numberexistingaccounts: count.toString(),
          numbersearchresults: filteredCount.toString(),
        })})`
      : `(${count})`
  }`;

  if (variant === "minimal") {
    return (
      <VerticalLayout margin={margin(2, 0, count && description ? 1 : 2, 0)}>
        {!!count && (
          <>
            <Title margin="0">{displayTitle}</Title>
            {description && <Description value={description} />}
          </>
        )}
      </VerticalLayout>
    );
  }
  const { Icon } = iconProps ?? {};
  return (
    <div
      style={{
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {Icon && (
          <div
            style={{
              alignItems: "center",
              display: "flex",
              height: dp(30),
              lineHeight: dp(30),
              width: dp(30),
            }}
          >
            <Icon className="h-[23.75px] w-[18.75px]" />
          </div>
        )}
        <Typography
          sx={{
            fontSize: dp(22),
            fontWeight: 700,
            lineHeight: dp(30),
          }}
        >
          {displayTitle}
        </Typography>
      </div>
      {description && (
        <div style={{ alignItems: "center", display: "flex" }}>
          <div style={{ display: "flex", height: dp(30), width: dp(30) }}></div>
          <Description value={description} />
        </div>
      )}
    </div>
  );
}

function Description({ value }: { value: string | React.JSX.Element }) {
  return typeof value === "string" ? (
    <Typography variant="body2">{value}</Typography>
  ) : (
    value
  );
}
